import { useCallback } from 'react';
import GooglePay from 'utils/GooglePay';

import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

// Placeholder-first flow: sync `loadPaymentData` in the tap so no `await`
// consumes transient user-activation before the paysheet dispatches. WebKit
// iOS Safari revokes activation on every tap, Chrome desktop revokes it on
// the second `PaymentRequest.show()` after paysheet close. INITIALIZE
// callback finishes the real init inside the paysheet.
export function useGooglePayBasket({
    transactionAmount,
    transactionCurrencyCode,
    isBopis = false,
    isSdd = false,
    onSuccess,
    onError,
    onCancel = () => {}
}) {
    const fireAnalyticsClick = useCallback(() => {
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
            data: {
                linkName: 'basket:payment:googlepay',
                actionInfo: 'basket:payment:googlepay',
                eventStrings: [anaConsts.Event.EVENT_71]
            }
        });
    }, []);

    const handleOutcome = useCallback(result => {
        if (result?.orderResponse) {
            onSuccess(result);
        }
    }, [onSuccess]);

    const handleError = useCallback(err => {
        if (err?.reason === GooglePay.GOOGLE_PAY_ERROR_MESSAGES.incompleteCheckout) {
            onCancel();

            return;
        }

        Sephora.logger.error('[GooglePay] paysheet failed', err);
        onError(err);
    }, [onCancel, onError]);

    const onTap = useCallback(async () => {
        fireAnalyticsClick();

        // Kick off synchronously in the click tick — see module header.
        const paysheetPromise = GooglePay.openPaysheetInitOnDemand({
            transactionAmount, transactionCurrencyCode, isBopis, isSdd
        });

        try {
            handleOutcome(await paysheetPromise);
        } catch (err) {
            handleError(err);
        }
    }, [transactionAmount, transactionCurrencyCode, isBopis, isSdd, fireAnalyticsClick, handleOutcome, handleError]);

    return { onTap };
}
